import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// 创建axios实例
const request = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 从localStorage获取token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      
      if (status === 401) {
        // token过期或未登录
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      } else if (status === 403) {
        // 无权限
        console.error('无权限访问');
      } else if (status === 404) {
        console.error('接口不存在');
      } else {
        console.error('服务器错误:', data.message);
      }
      
      return Promise.reject(data);
    }
    
    return Promise.reject(error);
  }
);

export default request;
